<template>
  <div>
    <div class="fixedNavbar">
      <div class="headText">
        <span class="span1">免费健康检测点一览表</span>
        <span class="span2"
          >携康将持续更新全国免费健康检测点信息，
          <br />更好的为公众健康提供检测服务</span
        >
      </div>
      <div id="testNavBar" class="main">
        <!-- <div id="testNavBar" class="main" :class="isFixTab ? 'fixedNavbar' : ''"> -->
        <h1>检测点列表</h1>
        <div class="search">
          <img
            class="search_img"
            src="../../assets/img/checkPoint/market_icon_search@2x.png"
            alt=""
            @click="searchInput"
          /><van-field
            v-model="searchWord"
            class="search_input"
            type="text"
            placeholder="搜索检测点"
            @keyup.enter="searchInput"
          />
        </div>
        <div class="searchPart flexCenter">
          <div class="left flexCenter">
            <div class="a_name" @click="addressShow = true">
              {{ provinceName }}
            </div>
            <img
              src="@/assets/img/checkPoint/record_icon_putitaway@2x.png"
              alt=""
              class="arrow-back"
              @click="addressShow = true"
            />
          </div>
          <div class="line"></div>
          <div class="right flexCenter">
            <div class="a_name" @click="addressShow = true">{{ cityName }}</div>
            <img
              src="@/assets/img/checkPoint/record_icon_putitaway@2x.png"
              alt=""
              class="arrow-back"
              @click="addressShow = true"
            />
          </div>
        </div>
      </div>
    </div>
    <div
      v-if="checkPointList && checkPointList.length == 0"
      style="text-align: center; position: fixed; top: 230px; left: 0; right: 0"
    >
      <img
        src="@/assets/img/checkPoint/noResult@2x.png"
        alt=""
        class="noResult"
      />
    </div>
    <div style="width: 100%; height: 240px"></div>
    <div class="commonPadding">
      <div v-if="checkPointList.length > 0" class="van-clearfix">
        <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh">
          <van-list
            v-model="isUpLoading"
            :finished="upFinished"
            :immediate-check="false"
            :offset="offset"
            finished-text="没有更多了"
            @load="onLoadList"
          >
            <ul class="newsUl van-clearfix" v-if="checkPointList.length > 0">
              <li
                class="actLi"
                v-for="(item, index) in checkPointList"
                :key="index"
              >
                <div class="topBox">
                  <span class="text1">{{ item.agencyName }}</span>
                  <div class="logoBox">
                    <a
                      style="float: left"
                      v-if="
                        isPhone && item.connectPhone && item.connectPhone != ''
                      "
                      :href="'tel:' + item.connectPhone"
                      class="i_logo"
                    >
                      <img
                        class="i_logo"
                        src="@/assets/img/checkPoint/icon_dianhua@2x.png"
                        alt=""
                      />
                    </a>
                    <a
                      style="float: left"
                      v-if="
                        !isPhone && item.connectPhone && item.connectPhone != ''
                      "
                      @click="toPhone(item.connectPhone)"
                      class="i_logo"
                    >
                      <img
                        class="i_logo"
                        src="@/assets/img/checkPoint/icon_dianhua@2x.png"
                        alt=""
                      />
                    </a>
                    <a
                      style="float: right"
                      @click="
                        goMap(
                          item.longitudines,
                          item.latitude,
                          item.agencyName,
                          item.address
                        )
                      "
                      class="i_logo"
                    >
                      <img
                        class="i_logo"
                        src="@/assets/img/checkPoint/icon_daohang@2x.png"
                        alt=""
                      />
                    </a>
                  </div>
                </div>
                <div class="bottomBox">
                  <span class="text2">地址：{{ item.address }}</span
                  ><span v-show="!item.isDistance" class="text3"
                    >{{ item.distance }}km</span
                  >
                  <span v-show="item.isDistance" class="text3"
                    >{{ item.distance }}m</span
                  >
                </div>
                <div class="line1"></div>
              </li>
            </ul>
          </van-list>
        </van-pull-refresh>
      </div>
    </div>
    <!-- <div class="van-clearfix inputTop">
      <div class="flexOne s_input flexCenter">
        <div class="searchPart flexCenter">
          <div class="a_name" @click="addressShow = true">{{ cityName }}</div>
          <img
            src="@/assets/img/arrow-back.png"
            alt=""
            class="arrow-back"
            @click="addressShow = true"
          />
        </div>
        <div class="flexOne flexCenter">
          <van-field
            v-model="searchWord"
            class="searchInput flexOne"
            placeholder="请输入关键词"
            @keyup.enter="searchInput"
          />
          <img
            src="@/assets/img/healthy_icon_search.png"
            alt=""
            class="search_icon_bg"
            @click="searchInput"
          />
        </div>
      </div>
    </div> -->
    <div class="mask" @click="c_cancel" v-if="addressShow"></div>
    <van-area
      title="选择地区"
      :area-list="areaList"
      v-if="addressShow"
      :value="defaultCode"
      :columns-num="2"
      @cancel="c_cancel"
      @confirm="c_confirm"
    />

    <!--    <div id="test">test</div>-->
  </div>
</template>
<script>
import {
  removeParams,
  removeUser,
  getToken,
  setToken,
  setUid,
  setIsSystem,
  removeToken,
  getCode,
  getUid,
  removeCode,
  removeUid,
} from "utils/auth";
import Is from "is_js";
import TMap from "components/Tmap/Tmap";
import MyStar from "components/MyStar/MyStar";
import EnvionmentVariables from "../../../baseUrl";
import {
  browserEnvironment,
  linkApp,
  parseTime,
  getUrlParam,
  isWeixin,
} from "utils/index";
import { CODE_OK } from "utils/publicData";
import { loadBMap } from "utils/BMap";
// import areaList from "utils/City";
import areaList from "utils/CityTest";
import codeList from "utils/bCityCodeCompare";
const wx = require("weixin-js-sdk");
export default {
  name: "checkPointPage",
  components: {
    TMap,
    MyStar,
  },
  data() {
    return {
      key: "P6BBZ-L25RQ-YGQ5W-GF6XH-CHGEH-FAFMW",
      baseImg: EnvionmentVariables.IMAGE_HOST,
      active: 0,
      tabAct: false,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100, // 滚动条与底部距离小于 offset 时触发load事件
      timer: null, // 下拉刷新定时器、
      tabIndex: 0,
      scrollLeft: 0,
      pageIndex: 1, // 请求第几页
      pageSize: 8, // 每页请求的数量
      total: 0, // 总共的数据条数
      areaList: areaList,
      addressShow: false,
      address: "",
      searchWord: "",
      province: "",
      provinceName: "获取",
      cityName: "获取",
      // areaCode: '440305',
      areaCode: "",
      defaultCode: "440300",
      loadingImges: {},
      longitude: "",
      latitude: "",
      isFixTab: false,
      isPhone: false,
      codeList: codeList,
      checkPointList: [
        // {
        //  agencyName: "兴东社区健康服务中心",
        //   address: "新安街道71区创业二路383号二楼",
        //   distance: "337m",
        //   phone: "15179783291",
        //   longitudes: 113.91728542751736,
        //   latitude: 22.57914333767361,
        // }
      ],
      PI: 3.14159265358979324,
      x_pi: (3.14159265358979324 * 3000.0) / 180.0,
    };
  },
  beforeCreate() {
    document
      .querySelector("body")
      .setAttribute("style", "background-color:#fff;");
  },
  created() {
    var token = this.$route.query.token;
    // // var areaCode = this.$route.query.areaCode + '000000';
    // // var province = this.$route.query.province + '000000';
    // // var provinceName = this.$route.query.provinceName;
    // // var cityName = this.$route.query.cityName;
    // // var district = this.$route.query.district;
    // // this.longitude = Number(this.$route.query.longitude);
    // // this.latitude = Number(this.$route.query.latitude);
    // // this.defaultCode = this.$route.query.defaultCode + '000000';
    // // console.log("this.$route.query");
    // // console.log(this.$route.query);
    // // console.log("longitude");
    // // console.log(this.longitude);
    // // console.log("latitude");
    // // console.log(this.latitude);
    // // console.log("defaultCode");
    // // console.log(this.defaultCode);
    console.log("token");
    console.log(token);
    if (token) {
      setToken(token);
    }
    // this.init()
    // if (province) {
    //   this.province = province;
    // }
    // if (areaCode) {
    //   this.areaCode = areaCode;
    // }
    // if (provinceName) {
    //   this.provinceName = provinceName;
    // }
    // if (cityName) {
    //   this.cityName = cityName;
    // }

    // if (areaCode) {
    //   this.getSysAgencyDetectionByPage();
    // } else {
    //   this.init()
    // }
    // this.onlyGetCode();
    this.init();
    // this.h5GetPosition()
  },
  mounted() {
    // if (this.defaultCode) {
    //   this.getSysAgencyDetectionByPage();
    // }
    if (isWeixin()) {
      this.isPhone = true;
      // 通过config接口注入权限验证配置
      this.getConfig();
    } else {
      this.isPhone = false;
    }
    window.addEventListener("scroll", this.handleTabFix, true);
  },
  // 离开当前组件前一定要清除滚动监听，否则进入其他路由会报错
  beforeRouteLeave(to, from, next) {
    window.removeEventListener("scroll", this.handleTabFix, true);
    next();
  },
  methods: {
    // h5 获取位置
    h5GetPosition(callBack) {
      var _this = this;
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          function (position) {
            var lat = position.coords.latitude; //纬度
            var lng = position.coords.longitude; //经度
            //alert("lat==>"+lat+"===>"+lng);
            //alert((typeof(lat) == undefined);
            console.log("position--");
            console.log(position);
            console.log("lat--");
            console.log(lat);
            console.log("lng--");
            console.log(lng);
            var coords = _this.gps84_To_Bd09(lat, lng);
            console.log("coords--");
            console.log(coords);
            callBack && callBack(coords);
          },
          function (error) {
            console.log("error--");
            console.log(error);
            switch (error.code) {
              case error.PERMISSION_DENIED: // 用户不允许地理定位
                // alert("User denied the request for Geolocation.");
                break;
              case error.POSITION_UNAVAILABLE: //无法获取当前位置
                alert("无法获取您当前的位置，请打开GPS后重试.");
                break;
              case error.TIMEOUT: //  操作超时
                // alert("The request to get user location timed out.");
                break;
              case error.UNKNOWN_ERROR:
                //alert("An unknown error occurred.");
                break;
            }
          },
          {
            // 指示浏览器获取高精度的位置，默认为false
            enableHighAccuracy: true,
            // 指定获取地理位置的超时时间，默认不限时，单位为毫秒
            timeout: 5000,
            // 最长有效期，在重复获取地理位置时，此参数指定多久再次获取位置。
            maximumAge: 3000,
          }
        );
      } else {
        alert("Geolocation is not supported by this browser.此设备不支持定位");
      }
    },
    outOfChina: function (lat, lon) {
      if (lon < 72.004 || lon > 137.8347) return true;
      if (lat < 0.8293 || lat > 55.8271) return true;
      return false;
    },
    transformLat: function (x, y) {
      var ret =
        -100.0 +
        2.0 * x +
        3.0 * y +
        0.2 * y * y +
        0.1 * x * y +
        0.2 * Math.sqrt(Math.abs(x));
      ret +=
        ((20.0 * Math.sin(6.0 * x * this.PI) +
          20.0 * Math.sin(2.0 * x * this.PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(y * this.PI) + 40.0 * Math.sin((y / 3.0) * this.PI)) *
          2.0) /
        3.0;
      ret +=
        ((160.0 * Math.sin((y / 12.0) * this.PI) +
          320 * Math.sin((y * this.PI) / 30.0)) *
          2.0) /
        3.0;
      return ret;
    },
    transformLon: function (x, y) {
      var ret =
        300.0 +
        x +
        2.0 * y +
        0.1 * x * x +
        0.1 * x * y +
        0.1 * Math.sqrt(Math.abs(x));
      ret +=
        ((20.0 * Math.sin(6.0 * x * this.PI) +
          20.0 * Math.sin(2.0 * x * this.PI)) *
          2.0) /
        3.0;
      ret +=
        ((20.0 * Math.sin(x * this.PI) + 40.0 * Math.sin((x / 3.0) * this.PI)) *
          2.0) /
        3.0;
      ret +=
        ((150.0 * Math.sin((x / 12.0) * this.PI) +
          300.0 * Math.sin((x / 30.0) * this.PI)) *
          2.0) /
        3.0;
      return ret;
    },
    delta: function (lat, lon) {
      var a = 6378245.0; //  a: 卫星椭球坐标投影到平面地图坐标系的投影因子。
      var ee = 0.00669342162296594323; //  ee: 椭球的偏心率。
      var dLat = this.transformLat(lon - 105.0, lat - 35.0);
      var dLon = this.transformLon(lon - 105.0, lat - 35.0);
      var radLat = (lat / 180.0) * this.PI;
      var magic = Math.sin(radLat);
      magic = 1 - ee * magic * magic;
      var sqrtMagic = Math.sqrt(magic);
      dLat =
        (dLat * 180.0) / (((a * (1 - ee)) / (magic * sqrtMagic)) * this.PI);
      dLon = (dLon * 180.0) / ((a / sqrtMagic) * Math.cos(radLat) * this.PI);
      return { lat: dLat, lon: dLon };
    },
    //84 to 火星坐标系 (GCJ-02)
    gps84_To_Gcj02: function (wgsLat, wgsLon) {
      if (this.outOfChina(wgsLat, wgsLon)) return { lat: wgsLat, lon: wgsLon };

      var d = this.delta(wgsLat, wgsLon);
      return { lat: wgsLat + d.lat, lon: wgsLon + d.lon };
    },
    //火星坐标系 (GCJ-02) to 百度坐标系 (BD-09)
    gcj02_To_Bd09: function (lat, lng) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng;
      let y = lat;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;
      return { lat: lats, lon: lngs };
    },
    gps84_To_Bd09: function (wgsLat, wgsLon) {
      let point = this.gps84_To_Gcj02(wgsLat, wgsLon);
      return this.gcj02_To_Bd09(point.lat, point.lon);
    },
    init() {
      const _this = this;
      // loadBMap("MmKNtMcwp0gV4Y0117ZS17PPBIHUT1bX").then((BMap) => {
      //   console.log("进来BMap");
      // loadBMap('sxpQFd2GkOjQ2Cqg7hs9E7t8HrS6O7E4').then(BMap => {
      // const geolocation = new BMap.Geolocation();
      // geolocation.getCurrentPosition(function (r) {
        //dcKVpLfWHNDpbEkhIeGdMtq70L1G67Ze
        //MmKNtMcwp0gV4Y0117ZS17PPBIHUT1bX
      _this.h5GetPosition(function (r) {
        $.ajax({
          url:
            "https://api.map.baidu.com/geocoder/v2/?ak=MmKNtMcwp0gV4Y0117ZS17PPBIHUT1bX&location=" +
            r.lat +
            "," +
            r.lon +
            "&output=json",
          dataType: "jsonp",
          callback: "BMap._rd._cbk43398",
          success: function (res) {
            console.log("output");
            console.log(res);
            var result = res.result,
              cityCode = result.cityCode; // 注意是市级code
            _this.provinceName = res.result.addressComponent.province;
            _this.cityName = res.result.addressComponent.city;
            _this.latitude = Number(r.lat);
            _this.longitude = Number(r.lon);
            _this.getStstemCode(cityCode);
          },
          error: function () {},
        });
      });
      // });
    },
    getStstemCode(cityCode) {
      for (var i in this.codeList.list) {
        if (i == cityCode) {
          this.areaCode = this.codeList.list[i];
          this.defaultCode = this.areaCode;
          console.log(this.defaultCode,1111);
          this.getSysAgencyDetectionByPage();
        }
      }
    },
    //  通过config接口注入权限验证配置
    getConfig() {
      let _this = this;
      // var url = localStorage.getItem("url");
      let url = window.location.href.split("#")[0];
      if (window.wechaturl !== undefined) {
        url = window.wechaturl;
      }
      var param = {
        service: "appagg",
        // query: encodeURIComponent((window.location.href).split('#')[0])
        // query: (window.location.href).split('#')[0]
        query: url,
      };
      console.log("url");
      console.log(url);
      // console.log("href")
      // console.log((window.location.href))
      // console.log("没有编码 url")
      // console.log((window.location.href).split('#')[0])
      // console.log("编码后 url")
      // console.log(encodeURIComponent((window.location.href).split('#')[0]))
      this.$api
        .getWechatSign(param)
        .then((res) => {
          if (res) {
            if (res.data.basis.status === 200) {
              console.log("result");
              console.log(res.data.result);
              let data = res.data.result;
              wx.config({
                debug: false,
                appId: data.appid,
                timestamp: data.timestamp,
                nonceStr: data.nonceStr,
                signature: data.signature,
                jsApiList: ["openLocation"],
                success: function (res) {
                  console.log("wx.config success");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
                fail: function (res) {
                  console.log("wx.config fail");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
              });
              wx.checkJsApi({
                // 判断当前客户端版本是否支持指定JS接口
                jsApiList: ["openLocation"],
                success: function (res) {
                  console.log("success");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
                fail: function (res) {
                  console.log("fail");
                  console.log(res);
                  // alert(JSON.stringify(res));
                },
              });
              wx.ready(function () {
                // wx.openLocation({
                //     latitude: 22.545538, // 纬度，浮点数，范围为90 ~ -90
                //     longitude: 114.054565, // 经度，浮点数，范围为180 ~ -180。
                //     name: '象山影视城', // 位置名
                //     address: '位置名的详情说明', // 地址详情说明
                //     scale: 10, // 地图缩放级别,整形值,范围从1~28。默认为最大
                // })
                // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
              });
              wx.error((err) => {
                console.log("err");
                console.log(err);
                // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
              });
            }
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    //将腾讯/高德地图经纬度转换为百度地图经纬度
    qqMapTransBMap(lng, lat) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng;
      let y = lat;
      let z = Math.sqrt(x * x + y * y) + 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) + 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta) + 0.0065;
      let lats = z * Math.sin(theta) + 0.006;

      return {
        lng: lngs,
        lat: lats,
      };
    },
    // 先分别获得id为testNavBar的元素距离顶部的距离和页面滚动的距离
    // 比较他们的大小来确定是否添加fixedNavbar样式
    handleTabFix() {
      var scrollTop =
        window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop;
      var offsetTop = document.querySelector("#testNavBar").offsetTop;
      scrollTop > offsetTop ? (this.isFixTab = true) : (this.isFixTab = false);

      this.$forceUpdate();
      // console.log(scrollTop, offsetTop, this.isFixTab, 11111111);
    },
    // 将百度地图经纬度转换为腾讯/高德地图经纬度
    bMapTransQQMap(lng, lat) {
      let x_pi = (3.14159265358979324 * 3000.0) / 180.0;
      let x = lng - 0.0065;
      let y = lat - 0.006;
      let z = Math.sqrt(x * x + y * y) - 0.00002 * Math.sin(y * x_pi);
      let theta = Math.atan2(y, x) - 0.000003 * Math.cos(x * x_pi);
      let lngs = z * Math.cos(theta);
      let lats = z * Math.sin(theta);

      return {
        lng: lngs,
        lat: lats,
      };
    },
    wx_goMap(longitudeAll, latitudeAll, agencyName) {
      console.log("wx_goMap");
      var dname = "地图";
      var address = agencyName;
      var coord = this.qqMapTransBMap(longitudeAll, latitudeAll);
      var latitude = parseFloat(coord.lat);
      var longitude = parseFloat(coord.lng);
      wx.openLocation({
        latitude,
        longitude,
        scale: 18,
        name: dname,
        address: address,
        success: function (res, data) {},
        fail: function (res) {
          console.log("openLocation_fail");
          console.log(res);
        },
      });
    },
    toPhone(phone) {
      console.log(phone, "phone");
      let options = {
        iphoneHasToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        iphoneNoToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidHasToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidNoToken: () => {
          let appParams = {
            pageType: "phoneCall",
            tel: phone,
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserHasToken: () => {},
        browserNoToken: () => {},
      };
      browserEnvironment(options);
    },
    goMap(longitude, latitude, agencyName, address) {
      let options = {
        token: getToken(),
        appletHasToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        appletNoToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        weiXinHasToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        weiXinNoToken: () => {
          if (longitude && latitude) {
            var coordinate = this.bMapTransQQMap(longitude, latitude);
            let that = this;
            // 公众号的方式在h5打开地图
            wx.openLocation({
              latitude: parseFloat(coordinate.lat), // 纬度，浮点数，范围为90 ~ -90
              longitude: parseFloat(coordinate.lng), // 经度，浮点数，范围为180 ~ -180。
              name: address, // 位置名
              address: agencyName, // 地址详情说明
              scale: 18, // 地图缩放级别,整形值,范围从1~28。默认为最大
              // infoUrl: 'http://www.ilanluo.com'
            });
          }
        },
        iphoneHasToken: () => {
          //在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address: address,
          //     agencyName: agencyName,
          //     // token: token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: { agencyName: agencyName,longitude: longitude, latitude: latitude },
          };
          linkApp(appParams, "", appParams.pageType);
        },
        iphoneNoToken: () => {
          //在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address: address,
          //     agencyName: agencyName,
          //     // token: token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: { agencyName: agencyName,longitude: longitude, latitude: latitude },
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidHasToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address: address,
          //     agencyName: agencyName,
          //     // token: token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: { agencyName: agencyName,longitude: longitude, latitude: latitude },
          };
          linkApp(appParams, "", appParams.pageType);
        },
        androidNoToken: () => {
          // 在h5用腾讯地图javaScript打开
          // this.$router.push({
          //   path: "/TCmap",
          //   query: {
          //     // province: this.province,
          //     // provinceName: this.provinceName,
          //     // cityName: this.cityName,
          //     // defaultCode: this.defaultCode,
          //     longitude: longitude,
          //     latitude: latitude,
          //     address: address,
          //     agencyName: agencyName,
          //     // token: token
          //   },
          // });
          let appParams = {
            pageType: "goMap",
            params: { agencyName: agencyName,longitude: longitude, latitude: latitude },
          };
          linkApp(appParams, "", appParams.pageType);
        },
        browserHasToken: () => {},
        browserNoToken: () => {},
      };
      browserEnvironment(options);
      // 跳回小程序打开地图
      // let options = {
      //   token: this.token,
      //   appletHasToken: () => {
      //     let xcxUrl = `/pages/bMap/bMap?latitude=${latitude}&longitude=${longitude}&agencyName=${agencyName}&address=${address}`;
      //     wx.miniProgram.navigateTo({ url: xcxUrl });
      //   },
      //   appletNoToken: () => {
      //     let xcxUrl = `/pages/bMap/bMap?latitude=${latitude}&longitude=${longitude}&agencyName=${agencyName}&address=${address}`;
      //     wx.miniProgram.navigateTo({ url: xcxUrl });
      //   },
      //   weiXinHasToken: () => {},
      //   weiXinNoToken: () => {},
      //   iphoneHasToken: () => {
      //     let appParams = {
      //       pageType: "gohome",
      //     };
      //     linkApp(appParams, "", appParams.pageType);
      //   },
      //   iphoneNoToken: () => {
      //     let appParams = {
      //       pageType: "gohome",
      //     };
      //     linkApp(appParams, "", appParams.pageType);
      //   },
      //   androidHasToken: () => {
      //     let appParams = {
      //       pageType: "gohome",
      //     };
      //     linkApp(appParams, "", appParams.pageType);
      //   },
      //   androidNoToken: () => {
      //     let appParams = {
      //       pageType: "gohome",
      //     };
      //     linkApp(appParams, "", appParams.pageType);
      //   },
      //   browserHasToken: () => {},
      //   browserNoToken: () => {},
      // };
      // browserEnvironment(options);
      // 在h5用腾讯地图javaScript打开
      // this.$router.push({
      //   path: "/Tmap",
      //   query: {
      //     // province: this.province,
      //     // provinceName: this.provinceName,
      //     // cityName: this.cityName,
      //     // defaultCode: this.defaultCode,
      //     longitude: longitude,
      //     latitude: latitude,
      //     agencyName: agencyName
      //     // token: this.token
      //   }
      // });
    },
    searchInput() {
      this.checkPointList = [];
      this.pageIndex = 1;
      this.getSysAgencyDetectionByPage();
    },
    // 获取检测点列表
    getSysAgencyDetectionByPage() {
      var that = this;
      // var coordinate = this.qqMapTransBMap(this.longitude, this.latitude);
      // 后台是腾讯地图的坐标
      var coordinate = {
        lng: this.longitude,
        lat: this.latitude,
      };
      var param = {
        service: "appagg",
        query: {
          provinceId: this.province,
          areaId: this.defaultCode,
          agencyName: this.searchWord,
          longitudines: parseFloat(coordinate.lng),
          latitude: parseFloat(coordinate.lat),
        },
        pageIndex: that.pageIndex,
        pageSize: that.pageSize,
      };
      this.$api
        .getSysAgencyDetectionByPage(param)
        .then((res) => {
          if (res) {
            that.total = res.data.rows;
            console.log(that.checkPointList.length, that.total, 333);
            // 数据全部加载完成
            if (that.checkPointList.length >= that.total) {
              that.upFinished = true; // 加载结束
            } else {
              that.checkPointList = that.checkPointList.concat(res.data.result);
              console.log(that.checkPointList, 222);
              that.checkPointList.forEach(function (item) {
                // item.distance = Math.round(item.distance);
                item.distance = that.getDistance(
                  coordinate.lat,
                  coordinate.lng,
                  item.latitude,
                  item.longitudines
                );
                item.isDistance = false;
                if (item.distance < 1) {
                  item.distance = item.distance * 1000;
                  item.isDistance = true;
                } else {
                  item.distance = Number(item.distance).toFixed(1);
                }
              });
            }
            if (res.data.result.length < that.pageSize) {
              that.upFinished = true;
            }
          }
        })
        .catch((err) => {
          console.log(err);
        })
        .finally(() => {
          console.log("finally");
          this.isDownLoading = false;
          this.isUpLoading = false;
        });
    },
    c_cancel() {
      this.addressShow = false;
    },
    c_confirm(array) {
      this.address = array[0].name + array[1].name;
      this.province = array[0].code;
      this.provinceName = array[0].name;
      this.cityName = array[1].name;
      this.areaCode = array[1].code;
      this.defaultCode = array[1].code;
      this.addressShow = false;
      this.pageIndex = 1;
      this.checkPointList = [];
      this.getSysAgencyDetectionByPage();
    },
    // 下拉刷新.
    onDownRefresh() {
      this.timer = setTimeout(() => {
        this.pageIndex = 1;
        this.checkPointList = [];
        this.upFinished = false; // 不写这句会导致你上拉到底过后在下拉刷新将不能触发下拉加载事件
        this.getSysAgencyDetectionByPage(); // 加载数据
        this.timer = null; // 清空定时器
      }, 300);
    },
    // 上拉加载
    onLoadList() {
      this.pageIndex++;
      this.getSysAgencyDetectionByPage();
    },
    rad(d) {
      return (d * Math.PI) / 180.0; //经纬度转换成三角函数中度分表形式。
    },
    getDistance(lat1, lng1, lat2, lng2) {
      //传入两个点的经纬度
      var radLat1 = this.rad(lat1);
      var radLat2 = this.rad(lat2);
      var a = radLat1 - radLat2;
      var b = this.rad(lng1) - this.rad(lng2);
      var s =
        2 *
        Math.asin(
          Math.sqrt(
            Math.pow(Math.sin(a / 2), 2) +
              Math.cos(radLat1) *
                Math.cos(radLat2) *
                Math.pow(Math.sin(b / 2), 2)
          )
        );
      s = s * 6378.137; // EARTH_RADIUS;
      s = Math.round(s * 10000) / 10000; //输出为公里
      s = s.toFixed(2); //保留小数点后两位小数
      return s;
    },
  },
};
</script>

<style scoped lang="less">
.fixedNavbar {
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 2032;
}
/deep/ .van-field__control {
  padding-right: 32px;
  padding-left: 16px;
}
/deep/ .van-cell {
  padding: 0 16px;
  padding-left: 0;
  background-color: #f5f5f5 !important;
  border-radius: 32px;
}
/deep/.van-field__value {
  display: flex;
}
/deep/ .van-picker {
  width: 100%;
  position: fixed;
  left: 0;
  bottom: 0;
  background: #fff;
  z-index: 10000;
}
/deep/.van-field__body {
  flex: 1;
}
.marginTop {
  margin-top: 230px;
}
.tmap {
  width: 100%;
  height: 600px;
}
.flexOne {
  flex: 1;
}
input::-webkit-input-placeholder {
  line-height: 50px;
}
.headText {
  width: 100%;
  height: 180px;
  background: linear-gradient(90deg, #3eabfd 0%, #357dfa 100%);
  display: flex;
  flex-direction: column;
}
.span1 {
  width: 100%;
  font-size: 32px;
  font-weight: bold;
  line-height: 44px;
  color: #ffffff;
  text-align: center;
  margin-top: 30px;
}
.span2 {
  width: 100%;
  font-size: 24px;
  font-weight: 400;
  line-height: 36px;
  color: #ffffff;
  text-align: center;
  margin-top: 14px;
}
.main {
  width: 100%;
  height: 274px;
  background: #ffffff;
  box-shadow: 0px 0px 2px rgba(0, 0, 0, 0.16);
}
h1 {
  // width: 100%;
  height: 44px;
  font-size: 32px;
  font-weight: bold;
  line-height: 36px;
  color: #2e2e2e;
  padding: 32px 0px 32px 32px;
}
.search {
  width: 686px;
  height: 64px;
  background: #f5f5f5;
  border-radius: 32px;
  display: flex;
  margin: 0 auto;
}
.search_img {
  width: 68px;
  height: 100%;
  margin-left: 16px;
}
.search_input {
  height: 100%;
  flex: 1;
  border: 0;
}
.searchPart {
  width: 100%;
  height: 40px;
  margin-top: 20px;
}
.a_name {
  font-size: 32px;
  color: #3e3e3e;
}
.arrow-back {
  width: 48px;
  height: 48px;
}
.left {
  flex: 1;
}
.right {
  flex: 1;
}
.line {
  width: 2px;
  height: 40px;
  background: #f5f5f5;
}
.actLi {
  width: 100%;
  box-sizing: border-box;
}
.topBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 34px;
  box-sizing: border-box;
}
.bottomBox {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-top: 28px;
  margin-bottom: 36px;
}
.text1 {
  font-size: 32px;
  font-weight: bold;
  line-height: 36px;
  color: #2e2e2e;
  margin-left: 32px;
}
.logoBox {
  width: 152px;
  // display: flex;
  // justify-content: space-between;
  margin-right: 32px;
}
.i_logo {
  width: 60px;
  height: 60px;
}
.text2 {
  font-size: 28px;
  font-weight: 400;
  line-height: 36px;
  color: #737373;
  margin-left: 32px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.text3 {
  font-size: 28px;
  font-weight: bold;
  line-height: 36px;
  color: #2e2e2e;
  margin-right: 32px;
}
.line1 {
  width: 686px;
  height: 2px;
  margin: 0 auto;
  background-color: #f5f5f5;
}
.noResult {
  width: 358px;
  height: 358px;
  margin: 0 auto;
  margin-top: 164px;
}
.headText1 {
  width: 100%;
  height: 180px;
}
</style>
